import { render, staticRenderFns } from "./SoilClass.vue?vue&type=template&id=6327fa78&scoped=true"
import script from "./SoilClass.vue?vue&type=script&lang=js"
export * from "./SoilClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327fa78",
  null
  
)

export default component.exports